module.exports = __webpack_public_path__ + "img/faviconblue.f2d42403.png";